import { IdentifikatorType } from '../reducer/sporsmalsflyt-types';
import {
    MAKSLENGDER,
    validateBankkontonummer,
    validateEpost,
    validateFodselsnummer,
    validateIsNonEmptyText,
    validateMobilnummer,
    validateOrganisasjonsnummer,
} from '../validation/validate';
import { CurrentKontaktinfosporsmal } from './kontaktinfo-types';

export enum Kontaktinfofelt {
    Navn = 'NAVN',
    Mobilnummer = 'MOBILNUMMER',
    Epost = 'EPOST',
    Fodselsnummer = 'FODSELSNUMMER',
    Fodselsdato = 'FODSELSDATO',
    Organisasjonsnummer = 'ORGANISASJONSNUMMER',
    Bankkontonummer = 'BANKKONTONUMMER',
    Adresse = 'ADRESSE',
}

export const getFeilmeldingFrom = (type: Kontaktinfofelt) => {
    switch (type) {
        case Kontaktinfofelt.Navn:
            return `Navn må ha en verdi og kan ikke være mer enn ${MAKSLENGDER.fornavn} tegn.`;
        case Kontaktinfofelt.Mobilnummer:
            return 'Vi trenger et norsk mobilnummer (8 siffer) for å kunne kontakte deg.';
        case Kontaktinfofelt.Epost:
            return 'Vi trenger en e-postadresse for å kunne kontakte deg. Er du sikker på at du har skrevet inn e-postadressen riktig?';
        case Kontaktinfofelt.Fodselsnummer:
            return 'Her mangler det et gyldig fødselsnummer. Fødselsnummer består av fødselsdato (DDMMÅÅ) og personnummer (5 siffer)';
        case Kontaktinfofelt.Organisasjonsnummer:
            return 'Her mangler det et gyldig organisasjonsnummer. Organisasjonsnummer består av 9 siffer';
        case Kontaktinfofelt.Bankkontonummer:
            return 'Du må oppgi et gyldig kontonummer med 11 siffer.';
        default:
            return '';
    }
};

export const removeSpaces = (value: string) => value.replace(/ /g, '');

function validateBankkontonummerIfSporsmalAsked(currentKontaktinfoSporsmal: CurrentKontaktinfosporsmal) {
    return currentKontaktinfoSporsmal.sporsmal.askForBankkontonummer
        ? validateBankkontonummer(currentKontaktinfoSporsmal.bankkontonummer)
        : true;
}

export const isValid = (currentKontaktinfoSporsmal: CurrentKontaktinfosporsmal, type: Kontaktinfofelt) => {
    switch (type) {
        case Kontaktinfofelt.Navn:
            return validateIsNonEmptyText(currentKontaktinfoSporsmal.navn);
        case Kontaktinfofelt.Mobilnummer:
            return validateMobilnummer(currentKontaktinfoSporsmal.mobilnummer);
        case Kontaktinfofelt.Epost:
            return validateEpost(currentKontaktinfoSporsmal.epost);
        case Kontaktinfofelt.Fodselsnummer:
            return validateFodselsnummer(currentKontaktinfoSporsmal.fodselsnummer);
        case Kontaktinfofelt.Organisasjonsnummer:
            return validateOrganisasjonsnummer(removeSpaces(currentKontaktinfoSporsmal.organisasjonsnummer));
        case Kontaktinfofelt.Bankkontonummer:
            return validateBankkontonummerIfSporsmalAsked(currentKontaktinfoSporsmal);
        default:
            return true;
    }
};

const fodselsnummerIsValid = (kontaktinfoSvar: CurrentKontaktinfosporsmal) => {
    if (kontaktinfoSvar.identifikatorType === IdentifikatorType.Fodselsnummer && kontaktinfoSvar.showFodselsnummer) {
        return isValid(kontaktinfoSvar, Kontaktinfofelt.Fodselsnummer);
    }
    return true;
};

const organisasjonsnummerIsValid = (kontaktinfoSvar: CurrentKontaktinfosporsmal) => {
    if (kontaktinfoSvar.identifikatorType === IdentifikatorType.Organisasjonsnummer) {
        return isValid(kontaktinfoSvar, Kontaktinfofelt.Organisasjonsnummer);
    }
    return true;
};

export const isKontaktinfoValid = (kontaktinfoSporsmal: CurrentKontaktinfosporsmal) =>
    isValid(kontaktinfoSporsmal, Kontaktinfofelt.Navn) &&
    isValid(kontaktinfoSporsmal, Kontaktinfofelt.Mobilnummer) &&
    isValid(kontaktinfoSporsmal, Kontaktinfofelt.Epost) &&
    fodselsnummerIsValid(kontaktinfoSporsmal) &&
    organisasjonsnummerIsValid(kontaktinfoSporsmal) &&
    (kontaktinfoSporsmal.sporsmal.askForBankkontonummer
        ? isValid(kontaktinfoSporsmal, Kontaktinfofelt.Bankkontonummer)
        : true);
